import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const a11yHiddenCss = css`
  border-color: transparent;
  clip: rect(0 0 0 0); 
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  top: 50%;
  white-space: nowrap; 
  width: 1px;
`;

export const UnstyledButtonWrap = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  color: ${({ isText, theme }) => (isText ? theme.palette.common.blue : '#333')};
  font-family: inherit;
  font-size: 1.4rem;
  line-height: ${({ isText }) => (isText ? '1.5' : '0.5')};
  padding: 0;

  &:focus {
    border-radius: 2px;
    box-shadow: 0 0 0 1px #666;
    outline: ${({ theme }) => `2px solid ${theme.palette.primary.main}`};
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;
